import { Icon } from './_Icon';
export const SparkleIcon = (props) => (
  <Icon {...props} d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
);
